import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { Header, Tabs, Container, PageContent, Alerts, PrivateComponent } from 'components';
import { Margin } from 'styled-components-spacing';
import { globalPropTypes } from 'helpers';
import { useTranslation } from 'react-i18next';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ma.events',
    url: '/ma/my-events',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.ma.events.ongoing',
    path: '/ma/my-events/ongoing',
    key: 'ongoing',
  },
  {
    title: 'navigation.tabs.ma.events.completed',
    path: '/ma/my-events/completed',
    key: 'completed',
  },
  {
    title: 'navigation.tabs.ma.events.cancelled',
    path: '/ma/my-events/cancelled',
    key: 'cancelled',
  },
  {
    title: 'navigation.tabs.ma.events.duplicated',
    path: '/ma/my-events/duplicated',
    key: 'duplicate',
  },
];

const MyEvents = ({ routes, bar, userPermissions }) => {
  const { t } = useTranslation();
  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/ma/my-events', firstTabPath);

  return (
    <>
      <Header
        breadcrumbs={breadcrumbs}
        title={t('page.ma.events.title')}
        renderActions={({ Button: ButtonRender }) => (
          <PrivateComponent
            permissions={{
              roles: ['ma_my_events_create_event'],
            }}
          >
            <ButtonRender secondary as={Link} to="/ma/event/create">
              {t('page.ma.events.createButton')}
            </ButtonRender>
          </PrivateComponent>
        )}
      />
      <Tabs items={tabs} />
      {renderExactRedirect()}
      <PageContent>
        <Container>
          <Margin bottom={{ md: 48 }}>
            <Alerts type="ma" />
          </Margin>
          {renderSubRoutes()}
        </Container>
      </PageContent>
    </>
  );
};

MyEvents.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  bar: PropTypes.shape({
    ongoing: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    cancelled: PropTypes.number.isRequired,
    duplicate: PropTypes.number.isRequired,
  }).isRequired,
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

MyEvents.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ ma, user }) => ({
  bar: ma.events.bar,
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(MyEvents);
